import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import { colors } from '../../utils/colors';
import { BrandAssets, FileUrls } from 'src/config';

const policy = [
	{
		name: 'Terms & conditions',
		url: FileUrls.termsAndCondition,
	},
	{
		name: 'Privacy Policy',
		url: FileUrls.dataProtectionPolicy,
	},
];

export const Copyright = () => {
	return (
		<Flex
			maxW="1240px"
			w={{ base: 'auto', md: '100%' }}
			mb={{ base: '15px', md: 0 }}
		>
			<Flex
				mt="45px"
				w="100%"
				p="37px 0"
				display={{ base: ' none', md: 'flex' }}
				justify="space-between"
				align="center"
			>
				<Text
					fontSize="12px"
					color="#8A8F98"
				>
					Copyright © {new Date().getFullYear()} by HashUp All Rights Reserved.
				</Text>
				<Flex>
					<Flex
						align="center"
						w="100%"
						justify="center"
						gridGap="20px"
					>
						<Image
							maxH="15px"
							src={BrandAssets.hodlLogo}
						/>
						<Flex
							fontSize="12px"
							color="#8A8F98"
							gridGap="15px"
							justify="space-between"
						>
							{policy.map(({ url, name }) => (
								<Link
									key={`cp_${url}_${name}`}
									target="_blank"
									href={url}
									cursor="pointer"
								>
									{name}
								</Link>
							))}
						</Flex>
					</Flex>
				</Flex>
			</Flex>
			<Box
				textAlign="center"
				fontSize="14px"
				color="#8A8F98"
				fontWeight="400"
				display={{ base: ' block', md: 'none' }}
			>
				<Flex
					mb="50px"
					flexDirection="column"
					gridGap="10px"
					fontSize="12px"
					fontWeight="400"
					textAlign="center"
					p="10px 0"
					color="white"
				>
					{policy.map(({ name, url }) => (
						<Link
							key={`cp_${url}_${name}`}
							target="_blank"
							href={url}
							cursor="pointer"
						>
							{name}
						</Link>
					))}
				</Flex>
				<Flex mb="5px">
					Copyright © {new Date().getFullYear()} by{' '}
					<Text
						m="0 5px"
						color={colors.primary}
					>
						HashUp
					</Text>
				</Flex>
				All Rights Reserved.
			</Box>
		</Flex>
	);
};
